import { render, staticRenderFns } from "./MenuCertificados.vue?vue&type=template&id=bc9c8f7a&scoped=true"
import script from "./MenuCertificados.vue?vue&type=script&lang=js"
export * from "./MenuCertificados.vue?vue&type=script&lang=js"
import style0 from "./MenuCertificados.vue?vue&type=style&index=0&id=bc9c8f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9c8f7a",
  null
  
)

export default component.exports